import { render, staticRenderFns } from "./FormEditorView.vue?vue&type=template&id=0a5042cc&scoped=true&"
import script from "./FormEditorView.vue?vue&type=script&lang=js&"
export * from "./FormEditorView.vue?vue&type=script&lang=js&"
import style0 from "./FormEditorView.vue?vue&type=style&index=0&id=0a5042cc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a5042cc",
  null
  
)

export default component.exports